import * as vp from 'vopay';

import { useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useGLCodes() {
  const source = axios.CancelToken.source();

  const [GLCodes, setGLCodes] = useState<vp.GlCode[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchGLCodes = async () => {
    try {
      setLoading(true);
      const res = await api.fetchGLCodes(source);
      setGLCodes(res.GLCodes);
      return res;
    } finally {
      setLoading(false);
    }
  };
  const reset = () => {
    setGLCodes([]);
  };

  return {
    loading,
    GLCodes,
    fetchGLCodes,
    reset,
  };
}
